// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { Box, DesktopItem } from 'components';
import React, { ReactElement } from 'react';
import './qualificationsTechnicalUDT.scss';
import { useTranslation } from 'react-i18next';

import useCheckColor from 'store/hooks/useCheckColor';
import { TechnicalUDTModel } from 'api/types/Technical';

interface Props {
  userId: number | null;
  dataTechnicalUDT: TechnicalUDTModel[] | null | undefined;
}

const QualificationsTechnicalUDT = (props: Props): ReactElement => {
  const { userId, dataTechnicalUDT } = props;
  const { t } = useTranslation('employee');

  //   START Color

  const checkColor = useCheckColor();

  // END Color

  return (
    <>
      {dataTechnicalUDT &&
      dataTechnicalUDT !== null &&
      Object.keys(dataTechnicalUDT)?.length > 0 ? (
        <Box
          id="userTechnicalUDTBox"
          name={t('userTechnicalUDT.technicalUDT')}
          noMarginBottom
          noShadow
          noPadding
          noRadius
          lightHeader
        >
          <div className="userTechnicalUDTContent">
            {Object.keys(dataTechnicalUDT)?.map((k) => (
              <DesktopItem
                id="qualifications"
                name={dataTechnicalUDT?.[k]?.qualification?.description}
              >
                <>
                  {dataTechnicalUDT?.[k]?.qualificationNumber !== null &&
                  dataTechnicalUDT?.[k]?.qualificationNumber !== '' &&
                  dataTechnicalUDT?.[k]?.qualificationNumber !== ' ' ? (
                    <div className="technicalUDTDetailBox">
                      <div className="technicalUDTLabel">
                        {t('userTechnicalUDT.qualificationNumber')}
                      </div>
                      <div className="technicalUDTValue">
                        {dataTechnicalUDT?.[k]?.qualificationNumber}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {dataTechnicalUDT?.[k]?.expirationQualificationDate !==
                  null ? (
                    <div
                      className={`dateTechnicalUDTBox ${checkColor(
                        dataTechnicalUDT?.[k]?.expirationQualificationDate,
                        'uprawnienia',
                        'udt'
                      )}`}
                    >
                      <div
                        className={`dateTechnicalUDTLabel ${checkColor(
                          dataTechnicalUDT?.[k]?.expirationQualificationDate,
                          'uprawnienia',
                          'udt'
                        )}`}
                      >
                        {t('userTechnicalUDT.expirationQualificationDate')}
                      </div>
                      <div
                        className={`dateTechnicalUDTValue ${checkColor(
                          dataTechnicalUDT?.[k]?.expirationQualificationDate,
                          'uprawnienia',
                          'udt'
                        )}`}
                      >
                        {dataTechnicalUDT?.[k]?.expirationQualificationDate}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  <div className="borderTop" />
                </>
              </DesktopItem>
            ))}
          </div>
        </Box>
      ) : null}
    </>
  );
};

export default QualificationsTechnicalUDT;
